var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "order-refund-review-customer-details flex flex-auto flex-col",
    },
    [
      _c("div", { staticClass: "title" }, [
        _vm._v("\n    Review refund summary\n  "),
      ]),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _vm._m(1),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "refund-customer-details" },
        [
          _c("el-card", { attrs: { shadow: "never" } }, [
            _c(
              "div",
              { staticClass: "flex flex-col" },
              [
                _c("div", { staticClass: "summary-header" }, [
                  _vm._v("\n          Items\n        "),
                ]),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("ItemRefundSummaryList", {
                  attrs: {
                    "items-to-refund": _vm.itemsToRefund,
                    "refund-shipping": _vm.refundShipping,
                    "shipping-total": _vm.shippingTotal,
                  },
                }),
                _vm._v(" "),
                _c("el-divider"),
                _vm._v(" "),
                _c("div", { staticClass: "flex flex-col" }, [
                  _c("div", { staticClass: "summary-header" }, [
                    _vm._v("\n            Customer info\n          "),
                  ]),
                  _vm._v(" "),
                  _c("br"),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "flex flex-col" }, [
                  _c("div", { staticClass: "flex flex-row" }, [
                    _c("div", { staticClass: "flex-1" }, [
                      _vm._v("\n              Name\n            "),
                    ]),
                    _vm._v(" "),
                    _c("div", [_vm._v(_vm._s(_vm.customer.customer_name))]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "flex flex-row" }, [
                    _c("div", { staticClass: "flex-1" }, [
                      _vm._v("\n              Phone Number\n            "),
                    ]),
                    _vm._v(" "),
                    _c("div", [_vm._v(_vm._s(_vm.customer.customer_phone))]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "flex flex-row" }, [
                    _c("div", { staticClass: "flex-1" }, [
                      _vm._v("\n              Email\n            "),
                    ]),
                    _vm._v(" "),
                    _c("div", [_vm._v(_vm._s(_vm.customer.customer_email))]),
                  ]),
                ]),
                _vm._v(" "),
                _c("el-divider"),
                _vm._v(" "),
                _c("div", { staticClass: "flex flex-col" }, [
                  _c("div", { staticClass: "summary-header" }, [
                    _vm._v("\n            Payments\n          "),
                  ]),
                  _vm._v(" "),
                  _c("br"),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "flex flex-col" }, [
                  _c("div", { staticClass: "flex flex-row" }, [
                    _c("div", { staticClass: "flex-1" }, [
                      _vm._v(
                        "\n              Total Refund Amount\n            "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", [
                      _vm._v(
                        "\n              " +
                          _vm._s(
                            _vm.formattedAmount(_vm.totalRefundAmount, "USD")
                          ) +
                          "\n            "
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "flex flex-row" }, [
                    _c("div", { staticClass: "flex-1" }, [
                      _vm._v("\n              Currency\n            "),
                    ]),
                    _vm._v(" "),
                    _c("div", [_vm._v(_vm._s(_vm.refundCurrency))]),
                  ]),
                ]),
              ],
              1
            ),
          ]),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "description" }, [
      _c("p", { staticClass: "note" }, [
        _vm._v(
          "\n      Take a quick look at the refund summary before processing the refund.\n      "
        ),
        _c("br"),
        _vm._v(" "),
        _c("span", { staticStyle: { "font-weight": "bold" } }, [
          _vm._v("Please note:"),
        ]),
        _vm._v(
          " custom refund\n      amounts do not include the tax portion that may be refunded\n      "
        ),
        _c("span", { staticStyle: { "font-weight": "bold" } }, [
          _vm._v("in addition"),
        ]),
        _vm._v(" to the displayed\n      custom amount.\n    "),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticStyle: { "margin-top": "24px" } }, [
      _c("div", { staticClass: "section-header" }, [
        _c("div", { staticClass: "flex-1" }, [
          _vm._v("\n        Refund Summary\n      "),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }